function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgAdd = function SvgAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.002 512.002",
    style: {
      enableBackground: "new 0 0 512.002 512.002"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29F5C"
    },
    d: "M418.258,249.103L405.252,143.45l-24.372,3l0.01-0.017l-47.25-26.591 c-5.04-2.836-10.824-4.07-16.583-3.538l-74.606,6.9c-9.171,0.848-17.366,6.081-21.993,14.045l-52.584,90.508 c-3.883,6.683-0.835,15.254,6.396,17.985l2.151,0.812c4.138,1.563,8.391,2.468,12.642,2.822l-6.663,5.803l-13.33,11.614 l-37.913,32.34c-6.749,5.879-7.45,16.109-1.571,22.858l3.846,4.405c7.55,8.658,20.691,9.557,29.365,2.005l14.49,16.62 c4.711,5.41,11.613,7.803,18.244,6.987c3.985-0.49,7.873-2.142,11.12-4.982l14.474,16.621c4.728,5.424,11.629,7.801,18.26,6.985 c3.985-0.491,7.874-2.127,11.122-4.966l7.866,6.798c7.552,8.673,20.708,9.57,29.382,2.018l10.693-9.329l89.896-70.012l0.097-0.089 l35.468-0.035L418.258,249.103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D37D42"
    },
    d: "M379.731,267.833l-0.097,0.089l-89.896,70.012l-10.693,9.329c-8.673,7.552-21.83,6.655-29.382-2.018 l-7.866-6.798c-3.248,2.839-7.138,4.476-11.122,4.966c-6.631,0.816-13.531-1.561-18.26-6.985l-14.474-16.621 c-3.248,2.839-7.136,4.491-11.12,4.982c-6.631,0.816-13.533-1.576-18.244-6.987l-14.49-16.62 c-7.426,6.466-18.118,6.718-25.781,1.227c-3.93,5.926-3.616,13.958,1.283,19.582l3.846,4.405c7.55,8.658,20.691,9.557,29.365,2.005 l14.49,16.62c4.711,5.41,11.613,7.803,18.244,6.987c3.985-0.49,7.872-2.142,11.12-4.982l14.474,16.622 c4.728,5.424,11.629,7.801,18.26,6.985c3.985-0.491,7.874-2.127,11.122-4.966l7.866,6.798c7.552,8.673,20.708,9.57,29.382,2.018 l10.693-9.329l89.896-70.012l0.097-0.089l35.468-0.035l-3.924-31.876L379.731,267.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9C295"
    },
    d: "M396.101,313.533l-48.165-41.53l-13.394-11.54l-9.584-8.254l-41.207-35.52l4.759-40.51 c1.61-13.701-7.015-26.528-20.311-30.207l-89.825-24.855c-9.504-2.63-19.549,1.78-24.045,10.557l-11.296,22.05l-48.488-3.291 l-12.42,105.724l-5.398,45.945l47.198,3.139l0.098,0.089l98.602,84.993l10.745,9.27c8.715,7.504,21.866,6.534,29.37-2.181 l14.38-16.686c3.263,2.821,7.162,4.436,11.15,4.905c6.635,0.78,13.523-1.636,18.221-7.086l14.382-16.701 c3.263,2.821,7.16,4.452,11.148,4.92c6.635,0.78,13.524-1.651,18.205-7.088l14.397-16.7c8.715,7.504,21.851,6.532,29.353-2.168 l3.822-4.427C403.64,329.601,402.882,319.375,396.101,313.533z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E59F6A"
    },
    d: "M396.101,313.533l-14.671-12.65c4.768,6.323,4.67,15.318-0.711,21.564l-4.057,4.699 c-7.964,9.235-21.908,10.267-31.16,2.301l-15.284,17.728c-4.969,5.771-12.282,8.351-19.326,7.524 c-4.233-0.497-8.37-2.228-11.834-5.223l-15.268,17.73c-4.987,5.785-12.298,8.349-19.342,7.522 c-4.233-0.497-8.372-2.212-11.836-5.207l-15.266,17.714c-2.876,3.341-6.539,5.592-10.474,6.752l6.499,5.607 c8.715,7.504,21.866,6.534,29.37-2.181l14.38-16.686c3.263,2.821,7.162,4.436,11.15,4.905c6.635,0.779,13.523-1.636,18.221-7.086 l14.382-16.701c3.263,2.821,7.16,4.452,11.148,4.92c6.635,0.78,13.524-1.651,18.205-7.088l14.397-16.7 c8.715,7.504,21.851,6.532,29.353-2.168l3.822-4.427C403.64,329.601,402.882,319.375,396.101,313.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E59F6A"
    },
    d: "M369.5,337.416l-26.392-22.756c-3.135-2.704-7.872-2.354-10.578,0.783 c-2.705,3.137-2.354,7.873,0.783,10.578l26.345,22.716l4.966-5.76c1.982,1.707,4.199,2.952,6.52,3.791 C372.857,343.719,372.25,339.787,369.5,337.416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E59F6A"
    },
    d: "M327.303,365.627c1.807-3.065,1.228-7.074-1.562-9.48l-23.708-20.441 c-3.137-2.704-7.872-2.354-10.578,0.783c-2.705,3.137-2.354,7.873,0.783,10.578l23.708,20.441c0.01,0.008,0.02,0.015,0.03,0.023 l4.898-5.688C322.827,363.532,325.011,364.785,327.303,365.627z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29F5C"
    },
    d: "M126.385,305.135l-5.713,7.544c-6.221,8.215-4.605,19.918,3.61,26.14l0,0 c8.215,6.221,19.918,4.605,26.14-3.61l5.713-7.544c6.221-8.215,4.605-19.918-3.61-26.14l0,0 C144.31,295.304,132.606,296.92,126.385,305.135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29F5C"
    },
    d: "M161.181,321.002l-10.759,14.207c-6.221,8.215-4.605,19.918,3.61,26.14l0,0 c8.215,6.221,19.918,4.605,26.14-3.61l10.759-14.207c6.221-8.215,4.605-19.918-3.61-26.14l0,0 C179.105,311.171,167.402,312.787,161.181,321.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29F5C"
    },
    d: "M194.834,338.377l-14.663,19.362c-6.221,8.215-4.605,19.918,3.61,26.14l0,0 c8.215,6.221,19.918,4.605,26.14-3.61l14.663-19.362c6.221-8.215,4.605-19.918-3.61-26.14l0,0 C212.759,328.545,201.056,330.162,194.834,338.377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29F5C"
    },
    d: "M225.435,359.783l-15.514,20.485c-6.221,8.215-4.605,19.918,3.61,26.14l0,0 c8.215,6.221,19.918,4.605,26.14-3.61l15.514-20.485c6.221-8.215,4.605-19.918-3.61-26.14l0,0 C243.359,349.952,231.656,351.568,225.435,359.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F29F5C"
    },
    d: "M380.89,146.433l-47.25-26.591c-5.04-2.836-10.824-4.07-16.583-3.538l-74.606,6.9 c-9.171,0.848-17.366,6.081-21.993,14.045l-52.584,90.508c-3.883,6.684-0.835,15.254,6.396,17.985l2.151,0.812 c19.275,7.28,41.043,1.085,53.596-15.252l20.147-26.22c0,0,48.429,56.073,101.749-9.41"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C9CEE"
    },
    d: "M511.945,309.145l-24.713-200.751c-0.243-1.974-1.26-3.771-2.828-4.995 c-1.568-1.224-3.557-1.774-5.532-1.532l-57.788,7.114c-15.009,1.848-25.716,15.562-23.868,30.57l19.844,161.2 c1.708,13.877,13.559,24.076,27.2,24.076c1.112,0,2.239-0.068,3.37-0.207l57.788-7.114 C509.528,316.999,512.451,313.256,511.945,309.145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3580D3"
    },
    d: "M511.945,309.145l-2.713-22.036c-1.23,1.805-3.194,3.095-5.532,3.383l-60.577,7.457 c-1.186,0.146-2.367,0.217-3.533,0.217c-10.2,0-19.441-5.442-24.553-13.84l2.022,16.424c1.708,13.877,13.559,24.076,27.2,24.076 c1.112,0,2.239-0.068,3.37-0.207l57.788-7.114C509.528,316.999,512.451,313.256,511.945,309.145z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED5575"
    },
    d: "M90.918,108.98l-57.788-7.114c-1.977-0.243-3.964,0.308-5.532,1.532 c-1.568,1.224-2.585,3.021-2.828,4.995L0.057,309.145c-0.506,4.111,2.417,7.854,6.527,8.36l57.788,7.114 c1.132,0.139,2.257,0.207,3.37,0.207c13.64,0,25.492-10.2,27.2-24.076l19.844-161.2C116.634,124.542,105.927,110.828,90.918,108.98z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CC3A60"
    },
    d: "M0.057,309.145l2.713-22.036c1.23,1.805,3.194,3.095,5.532,3.383l60.577,7.457 c1.186,0.146,2.367,0.217,3.533,0.217c10.2,0,19.441-5.442,24.553-13.84l-2.022,16.424c-1.708,13.877-13.559,24.076-27.2,24.076 c-1.112,0-2.239-0.068-3.37-0.207l-57.788-7.114C2.473,316.999-0.449,313.256,0.057,309.145z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EBEEF2"
    },
    cx: 464,
    cy: 277.001,
    r: 14.498
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EBEEF2"
    },
    cx: 47.19,
    cy: 277.001,
    r: 14.498
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add.aeaac61c.svg";
export { ForwardRef as ReactComponent };